exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._16HEqdDoFSW7H5pyzLevkN{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir=ltr] ._16HEqdDoFSW7H5pyzLevkN{padding-left:8px}html[dir=rtl] ._16HEqdDoFSW7H5pyzLevkN{padding-right:8px}html[dir=ltr] ._3wyQV2paawj4V1KhuHmxQ7{margin-left:5px}html[dir=rtl] ._3wyQV2paawj4V1KhuHmxQ7{margin-right:5px}._26S58PQUZcjrU2dKywlGSB{width:32;height:32;display:inline-block}html[dir] ._26S58PQUZcjrU2dKywlGSB{background-color:transparent}html[dir] ._1OEhAnyFwpJIfpAs2RBXzU{margin:0}", ""]);

// exports
exports.locals = {
	"sendSpinner": "_16HEqdDoFSW7H5pyzLevkN",
	"sendSpinnerText": "_3wyQV2paawj4V1KhuHmxQ7",
	"icon": "_26S58PQUZcjrU2dKywlGSB",
	"iconDefault": "_1OEhAnyFwpJIfpAs2RBXzU"
};